import http from '@/utils/request';
// 获取验证码
export function getCodeImg() {
  return http.request({
    url: '/code',
    headers: {
      isToken: false,
    },
    method: 'get',
    timeout: 20000,
  });
}

// 登录方法
export function login(username, password, code, uuid) {
  return http.request({
    url: '/auth/login',
    headers: {
      isToken: false,
    },
    method: 'post',
    data: { username, password, code, uuid },
  });
}

// 短信登录
export function smslogin(phone, code) {
  return http.request({
    url: '/auth/loginByPhone',
    headers: {
      isToken: false,
    },
    method: 'post',
    data: { phone, code },
  });
}

//获取用户信息
export function getInfo() {
  return http.request({
    url: '/system/user/getInfo',
    method: 'get',
  });
}
// 退出方法
export function logout() {
  return http.request({
    url: '/auth/logout',
    method: 'delete',
  });
}

//获取微信登录二维码
export function getWechatQr() {
  return http.request({
    url: '/system/weChatOa/rest/getTempLoginQrCode',
    headers: {
      isToken: false,
    },
    method: 'get',
  });
}

//获取微信登录二维码扫描状态
export function getWechatQrScanned(code) {
  return http.request({
    url: `/system/weChatOa/rest/userScanLogin?sceneId=${code}`,
    headers: {
      isToken: false,
    },
    method: 'get',
  });
}

//微信注册
export function wechatRegister(data) {
  return http.request({
    url: '/system/user/rest/weChatregister',
    headers: {
      isToken: false,
    },
    method: 'post',
    data,
  });
}

// 获取门户的 token
export function singleLoginZdcloud() {
  return http.request({
    url: '/auth/singleLoginZdcloud',
    method: 'post',
  });
}
